import FileSaver from 'file-saver';

/**
 *
 * @version 2026-09-02
 * @author Patrik Harag
 */

const SEPARATOR = ';';

/**
 *
 * @param val {number}
 * @return {string}
 */
export function formatNumber(val) {
    return Number(Number(val).toFixed(2)).toLocaleString('cs', {
        minimumFractionDigits: 2,
        useGrouping: false
    });
}

/**
 *
 * @param value {*}
 * @return {string}
 */
export function escapeCell(value) {
    let s = (value == null) ? '' : String(value);
    if (s.includes('"') || s.includes(SEPARATOR) || s.includes('\n') || s.includes('\r')) {
        return '"' + s.replace(/"/g, '""') + '"';
    }
    return s;
}

/**
 *
 * @param rows {string[][]}
 * @return {string}
 */
export function toCsv(rows) {
    return rows.map(row => row.map(escapeCell).join(SEPARATOR)).join('\r\n');
}

/**
 *
 * @param filename {string}
 * @param rows {string[][]}
 */
export function downloadCsv(filename, rows) {
    const csv = '\uFEFF' + toCsv(rows);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    FileSaver.saveAs(blob, filename);
}
